import $ from 'jquery'
import {initStore} from './redux/store'
import {Feature, isEnabled} from './features/index'
import {FAKE_WORKFLOW_STATUSES} from './workflowStatus/constants'
import {getSavedActiveTabNumOrDefault} from "./administration/userManagement/common/utils"
import {
    getCommentsOrderFromLocalStorage,
    getCustomerNewCommentsTextsFromLocalStorage,
    getProjectNewCommentsTextsFromLocalStorage,
    getTaskNewCommentsTextsFromLocalStorage
} from './panels/comments/utils'
import {getCpPanelClosedStateInLocalStorage, getSingleCPSelectionFromLocalStorage} from './taskManagement/common/utils'
import {initLocalStorage} from './util/LocalStorage'
import {loadCPPanelCollapsedCustomersFromLocalStorage, loadCpPanelWidthFromLocalStorage} from './taskManagement/customersProjectsPanel/utils'
import ToastsContainer from './toasts/components/ToastsContainer'
import {getStoredCollapsedProjectsState} from './taskManagement/kanban/utils'
import {getStoredDARSettingsCollapsedState} from './administration/darSettings/utils'
import {getWorkScheduleSelectedYear} from './administration/workSchedule/utils'
import LicenseCountDownTip from './components/licenseCountDownTip/LicenseCountDownTip'
import SupportQuestionButton from './support/supportForm/SupportQuestionButton'
import ContactSupportDraggablePopupContainer from './support/supportForm/ContactSupportDraggablePopupContainer'
import {getSupportPopupInfoFromLocalStorage} from './support/supportForm/utils'

/**
 * Common place for init all application data.
 * Place there initialization of all stores that used between several pages
 */
export default function initApplication() {
    const INIT_DATA = window.__INIT_APP_DATA__

    if (!INIT_DATA.WORKFLOW_STATUSES || !isEnabled(Feature.TWS)) {
        INIT_DATA.WORKFLOW_STATUSES = FAKE_WORKFLOW_STATUSES
    }

    // load data from cookies
    INIT_DATA.USER_MANAGEMENT.ACTIVE_TAB_NUM = getSavedActiveTabNumOrDefault()

    // load data from local storage
    initLocalStorage(INIT_DATA.LOGGED_IN_USER.id)

    INIT_DATA.COMMENTS = {
        TASK_NEW_COMMENTS: getTaskNewCommentsTextsFromLocalStorage(),
        PROJECT_NEW_COMMENTS: getProjectNewCommentsTextsFromLocalStorage(),
        CUSTOMER_NEW_COMMENTS: getCustomerNewCommentsTextsFromLocalStorage(),
        IS_NEW_COMMENTS_ON_TOP: getCommentsOrderFromLocalStorage()
    }

    INIT_DATA.TASK_MANAGEMENT.CP_PANEL_CLOSED = getCpPanelClosedStateInLocalStorage()
    INIT_DATA.TASK_MANAGEMENT.CP_PANEL_WIDTH = loadCpPanelWidthFromLocalStorage()
    INIT_DATA.TASK_MANAGEMENT.CP_PANEL_COLLAPSED_CUSTOMERS = loadCPPanelCollapsedCustomersFromLocalStorage()
    INIT_DATA.TASK_MANAGEMENT.KANBAN_COLLAPSED_PROJECTS_STATE = getStoredCollapsedProjectsState()
    INIT_DATA.TASK_MANAGEMENT.SINGLE_CP_SELECTION = getSingleCPSelectionFromLocalStorage()

    INIT_DATA.GENERAL_SETTINGS = {
        DAR_SETTINGS_COLLAPSED_STATE: getStoredDARSettingsCollapsedState(),
    }

    INIT_DATA.WORK_SCHEDULE = {
        SELECTED_YEAR: getWorkScheduleSelectedYear()
    }

    INIT_DATA.SUPPORT = {
        ...INIT_DATA.SUPPORT,
        POPUP_INFO: {
            ...getSupportPopupInfoFromLocalStorage(),
        },
    }

    initStore(INIT_DATA)

    initCommonComponents()
}

function initCommonComponents() {
    const $body = $('body')
    new ToastsContainer().init($body)
    new LicenseCountDownTip().init($body)
    new SupportQuestionButton().init($('.contactSupportButtonPlaceholder'))
    new ContactSupportDraggablePopupContainer().init()
}


// WEBPACK FOOTER //
// ./web/js/initApplication.js